
export const autoRefresh = (callback: () => void) => {
    callback();
    const intervalId = setInterval(callback, 5000);
    return () => {
        clearInterval(intervalId);
    }
}
